import React from "react";
import { Modal } from "react-bootstrap";

interface GuestSaveVoteModalProps {
  onSuccess: (success: any) => void;
  onClose: (success: any) => void;
  shouldShow: boolean;
}

export default function GuestSaveVoteModal({ onSuccess, onClose, shouldShow }: GuestSaveVoteModalProps) {
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Header>
          <h2 className="modal-header-text">Save Your Vote</h2>
          <button type="button" className="btn-close btn-close-white" onClick={() => onClose(true)}></button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body">
            <h4 className="rider-name-content">
              <p>Do you want to save your vote? Please login first to save or you can skip</p>
            </h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={() => onClose(true)}>
              Skip
            </button>
          </div>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={() => onSuccess(true)}>
              Save
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
